<h1 mat-dialog-title>
  View Only
</h1>
    
<div mat-dialog-content>
  <span class="text-14">This content is currently set to view only, and changes made will be saved to a copy. </span>
</div>

<div mat-dialog-actions>
  <button app-button buttonType="primary" [mat-dialog-close]="true" cdkFocusInitial style="min-width: 100px;">OK</button>
</div>